import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { AccountProvider } from "./lib/useAccount";
import "./styles/theme.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("Missing #root element — index.html did not load correctly.");
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <AccountProvider>
        <App />
      </AccountProvider>
    </BrowserRouter>
  </StrictMode>,
);
